import script from "./sf-skeleton-loader.vue?vue&type=script&lang=ts&setup=true"
export * from "./sf-skeleton-loader.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__